import { createRouter, createWebHashHistory } from 'vue-router';
import TheSelectCase from './UI/TheSelectCase.vue';
import TheConfigurator from './UI/TheConfigurator.vue';
import TheMobile from '@/UI/TheMobile.vue';
import { isMobile } from 'mobile-device-detect';
import TheMobileAR from '@/UI/TheMobileAR.vue';


const routes = [
    {
        path: '/',
        redirect: '/selectCase',
        children: [
            {
                path: '/selectCase',
                component: TheSelectCase,
                query: {},
                toolChest: {},
            },
            {
                path: '/configurator',
                component: TheConfigurator,
                query: {},
                toolChest: {},
            },
            {
                path: '/mobile',
                redirect: '/mobile/viewer',
                query: {},
                toolChest: {},
                children: [
                    {
                        path: '/mobile/viewer',
                        component: TheMobile,
                        query: {},
                        toolChest: {},
                    },
                    {
                        path: '/mobile/ar',
                        component: TheMobileAR,
                        query: {},
                        toolChest: {},
                    },
                ],
            },
            // {
            //     path: '/configurator',
            //     component: () => import('./UI/TheConfigurator.vue'), // ленивая загрузка
            // },
            {
                path: '/:pathMatch(.*)*', // Ловит все несуществующие пути
                component: TheSelectCase, // Компонент для 404
                query: {},
            },
        ],
    },

];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


//сбрасываем position, чтоб при перезагрузке страницы и при откр в новой вкладке currentState обнулить
//currentState и previousState нужно чтоб на стрелочку назад переходить сразу к selectCase
history.replaceState(null, '');
history.replaceState({ position: 0 }, '');

let previousState = window.history.state?.position || 0;
router.beforeEach((to, from, next) => {
    const queryParams = to.query;
    const mobilePaths = [ '/mobile', '/mobile/viewer', '/mobile/ar' ];
    const currentState = window.history.state?.position || 0;

    if (isMobile && !mobilePaths.includes(to.path)) {
        next({ path: '/mobile', query: queryParams });
    } else if (!isMobile && mobilePaths.includes(to.path)) {
        next({ path: '/configurator', query: queryParams });
    //вперед двигаемся по истории(по шагам), назад сразу к /selectCase
    }
    // else if (
    //     to.path === '/configurator' &&
    //     from.path === '/configurator' &&
    //     currentState !== 0 &&
    //     currentState <= previousState) {
    //         next({ path: '/selectCase' });
    // }
    else {
        next();
    }
    previousState = currentState;
});

export default router;
